import { About, Testimonial } from './../../@resources/graphql/types/types';
import { TestimonialService } from './../../@resources/services/testimonial.service';
import { HealthEducationService } from 'src/app/@resources/services/health-education.service';
import { NewService } from '../../@resources/services/new.service';
import { ServiceService } from '../../@resources/services/service.service';
import { OfferService } from '../../@resources/services/offer.service';
import { Component, OnInit } from '@angular/core';
import {
  HealthEducation,
  New,
  Offer,
  PaginationOptions,
  Service,
  Slogan,
} from '../../@resources/graphql/types/types';
import { SloganService } from 'src/app/@resources/services/slogan.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AboutService } from '../../@resources/services/about.service';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';
import { SeoService } from '../../@resources/services/SEO.service';
import AOS from 'aos';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  services: Service[];
  offers: Offer[];
  healthEducations: HealthEducation[];
  news: New[];
  about: About;
  slogan: Slogan;
  testimonials: Testimonial[];
  paginationOptions: PaginationOptions = { limit: 0, page: 0 };
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 600,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      760: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
    nav: true,
  };
  constructor(
    private servicesService: ServiceService,
    private offerService: OfferService,
    private healthEducationService: HealthEducationService,
    private newService: NewService,
    private sloganService: SloganService,
    private testimonialService: TestimonialService,
    private readonly seoService: SeoService,
    private localStorage: LocalStorageService,
    private aboutService: AboutService
  ) {}

  ngOnInit(): void {
    AOS.init();
    this.listServices();
    this.listOffers();
    this.listHealthEducations();
    this.listNews();
    this.listSlgoan();
    this.listTestimonials();
    this.listAbout();
    this.setTitle();
  }
  setTitle() {
    const lang = this.localStorage.get('lang');
    lang == 'en'
      ? this.seoService.updateTitle('Home')
      : this.seoService.updateTitle('الرئيسية');
  }
  listServices() {
    let paginationOptions = { limit: 4, page: 1 };
    this.servicesService
      .listServices(paginationOptions)
      .subscribe((res: any) => {
        this.services = res.data.services;
      });
  }

  listOffers() {
    let paginationOptions = { limit: 4, page: 1 };
    this.offerService.listOffers(paginationOptions).subscribe((res: any) => {
      this.offers = res.data.offers;
    });
  }

  listHealthEducations() {
    let paginationOptions = { limit: 3, page: 1 };
    this.healthEducationService
      .listHealthEducations(paginationOptions)
      .subscribe((res: any) => {
        this.healthEducations = res.data.healthEducations;
      });
  }

  listNews() {
    let paginationOptions = { limit: 3, page: 1 };
    this.newService.listAllNews(paginationOptions).subscribe((res: any) => {
      this.news = res.data.allNews;
    });
  }

  listAbout() {
    this.aboutService.listAbout().subscribe((res: any) => {
      this.about = res?.data?.about;
    });
  }

  listSlgoan() {
    this.sloganService.listSlogan().subscribe((res: any) => {
      this.slogan = res?.data?.slogans;
    });
  }

  listTestimonials() {
    this.testimonialService
      .listTestimonials(this.paginationOptions)
      .subscribe(({ data }) => {
        this.testimonials = data['testimonials'];
      });
  }
}
